import { Shield, ShieldCheck } from 'lucide-react'
import { StatusBadge, type StatusBadgeSize } from './StatusBadge'
import type { UserRole } from '@/types'

interface RoleBadgeProps {
  role: UserRole | null | undefined
  size?: StatusBadgeSize
  className?: string
}

const CONFIG = {
  admin: {
    label: 'Admin',
    icon: ShieldCheck,
    tone: 'bg-red-50 text-red-700 border border-red-200',
    title: 'CRMPeeps administrator',
  },
  moderator: {
    label: 'Moderator',
    icon: Shield,
    tone: 'bg-blue-50 text-blue-700 border border-blue-200',
    title: 'CRMPeeps moderator',
  },
} as const

/**
 * Staff role badge shown alongside member names across the platform.
 * Renders nothing for regular users — only moderators/admins get a badge.
 */
export function RoleBadge({ role, size = 'md', className }: RoleBadgeProps) {
  if (role !== 'admin' && role !== 'moderator') return null
  const config = CONFIG[role]
  const Icon = config.icon
  return (
    <StatusBadge
      size={size}
      tone={config.tone}
      title={config.title}
      className={className}
      icon={(cls) => <Icon className={cls} />}
    >
      {config.label}
    </StatusBadge>
  )
}
